export default "__VITE_ASSET__17e849a2__"